import { render } from "./Index-elecBoard.vue?vue&type=template&id=0e4bcb7f"
import script from "./Index-elecBoard.vue?vue&type=script&lang=js"
export * from "./Index-elecBoard.vue?vue&type=script&lang=js"

import "./Index-elecBoard.vue?vue&type=style&index=0&id=0e4bcb7f&lang=css"

import exportComponent from "D:\\A_Projcets_Code\\mes-chunyu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__